import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, employeePayrollGetbyCompany } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const EmployeePayoll = () => {
  const [apiData, setApiData] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loadingCompany, setLoadingComapany] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    company_id: null,
    pay_month: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(false)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, [])

  const handleButton = () => {
    navigate('/payroll/generate')
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log('Inside the submit try');

      const responseData = await employeePayrollGetbyCompany(formData);
      if (responseData.data) {
        const payrolls = responseData.data.map(i => ({
          _id: i._id,
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          company: i.company,
          Design: i.Design,
          pay_month: i.pay_month,
          basic_pay: i.basic_pay,
          attendance_allowence: i.attendance_allowence,
          overtime_pay: i.overtime_pay,
          standard_gross: i.standard_gross,
          allowences: i.allowences,
          incentives: i.incentives,
          lop: i.lop,
          earned_gross: i.earned_gross,
          advances: i.advances,
          other: i.other,
          netpay: i.netpay
        }));
        setApiData(payrolls);
        setIsLoading(false);
      } else {
        alert('No Data Received')
      }
    } catch (err) {
      setIsLoading(true);
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Payroll: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Employee Payroll' showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Employee Payroll Details
          <div className="d-flex flex-column align-items-end">
            <Button variant="primary" className="d-flex align-items-center mb-2" onClick={handleButton}>
              Generate Payroll
            </Button>
          </div>
        </h4>
        <Form onSubmit={handleSubmit} className="mt-4 align-items-center">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Organization</option>
                {loadingCompany ? (<div>Loading...</div>) : (organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="pay_month">
              <Form.Label>Select Month</Form.Label>
              <Form.Control
                type="month"
                name="pay_month"
                value={formData.pay_month}
                onChange={handleChange}
                required
                style={{height:'30px'}}
              >
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} md='4'>
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px',height:'30px' }}>
                View Payroll
              </Button>
            </Form.Group>
          </Row>
        </Form>
        {isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div style={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Emp Id</th>
                <th className="fs-12">Name</th>
                <th className="fs-12">Desigination</th>
                <th className="fs-12">Paymonth</th>
                <th className="fs-12">Basic Pay</th>
                <th className="fs-12">Attendance Allowence</th>
                <th className="fs-12">Overtime Pay </th>
                <th className="fs-12">Standard Gross</th>
                <th className="fs-12">Allowences</th>
                <th className="fs-12">Incentives</th>
                <th className="fs-12">Loss of Pay</th>
                <th className="fs-12">Earned Gross</th>
                <th className="fs-12">Advances</th>
                <th className="fs-12">Others</th>
                <th className="fs-12">Netpay</th>

              </tr>
            </thead>
            <tbody>
              {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.emp_id}
                  </td>
                  <td className="fs-12">
                    {emp.emp_name}
                  </td>
                  <td className="fs-12">
                    {emp.Design}
                  </td>
                  <td className="fs-12">
                    {emp.pay_month}
                  </td>
                  <td className="fs-12">
                    {emp.basic_pay}
                  </td>
                  <td className="fs-12">
                    {emp.attendance_allowence}
                  </td>
                  <td className="fs-12">
                    {emp.overtime_pay}
                  </td>
                  <td className="fs-12">
                    {emp.standard_gross}
                  </td>
                  <td className="fs-12">
                    {emp.allowences}
                  </td>
                  <td className="fs-12">
                    {emp.incentives}
                  </td>
                  <td className="fs-12">
                    {emp.lop}
                  </td>
                  <td className="fs-12">
                    {emp.earned_gross}
                  </td>
                  <td className="fs-12">
                    {emp.advances}
                  </td>
                  <td className="fs-12">
                    {emp.other}
                  </td>
                  <td className="fs-12">
                    {emp.netpay}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>}
      </Container>
    </div>
  );

}

export default EmployeePayoll;